export const buildPlaceholderMultiSelect = (
  value = [],
  data = [],
  { empty, all = 'All', singleFallback = '', multiple = count => `Filtered to ${count}` }
) => {
  const count = value.length

  if (count === 0) return empty
  if (count === 1) {
    return data.find(item => item.value === value[0])?.text ?? singleFallback
  }

  if (count === data.length) return all

  return multiple(count)
}
